import create from 'zustand/vanilla';
import createHook from 'zustand';
import { emptyObject } from '@constants/empty';

export const practiceStore = create((set) => ({
  practiceSelectedTopic: emptyObject,
  setPracticeSelectedTopic: (topic) =>
    set((state) => ({
      ...state,
      practiceSelectedTopic: { ...topic }
    }))
}));

const usePracticeStore = createHook(practiceStore);

export default usePracticeStore;
